<div class="block--content-stw block">
    <div class="block--wrap block">
        <rwidget-alert></rwidget-alert>
        <div class="block-full-width flex flex-col gap-4">
            <div class="flex flex-col justify-center gap-4 md:flex-row" *ngIf="env.AUTH_FEATURES?.length">
                <button
                    class="flex min-h-[5rem] flex-1 flex-col items-center justify-items-center rounded-md border-2 border-solid px-4 shadow-[0_0_20px_rgba(0,0,0,0.1)] dark:border-contrast-yellow"
                    *ngIf="env.AUTH_FEATURES?.includes('ID-CARD')"
                    [ngClass]="{
                        'border-secondary-button text-secondary-button bg-[#F1F8F5] dark:bg-contrast-yellow':
                            method === 'ID-CARD'
                    }"
                    [attr.disabled]="verificationCode ? 'true' : null"
                    (click)="setMethod('ID-CARD')">
                    <img
                        class="flex flex-1 items-center dark:filter-yellow"
                        [ngClass]="{ 'dark:filter-black': method === 'ID-CARD' }"
                        width="32"
                        height="auto"
                        alt=""
                        src="./assets/img/idcard.svg" />
                    <span
                        class="flex flex-1 items-center text-primary"
                        [ngClass]="method === 'ID-CARD' ? 'dark:text-contrast-black' : 'dark:text-contrast-yellow'">
                        {{ 'BTN_ID_CARD_LOGIN' | translate }}
                    </span>
                </button>

                <button
                    class="flex min-h-[5rem] flex-1 flex-col items-center justify-items-center rounded-md border-2 border-solid px-4 shadow-[0_0_20px_rgba(0,0,0,0.1)] dark:border-contrast-yellow"
                    *ngIf="env.AUTH_FEATURES?.includes('MOBILE-ID')"
                    [ngClass]="{
                        'border-secondary-button text-secondary-button bg-[#F1F8F5] dark:bg-contrast-yellow':
                            method === 'MOBILE-ID'
                    }"
                    [attr.disabled]="verificationCode ? 'true' : null"
                    (click)="setMethod('MOBILE-ID')">
                    <img
                        class="flex flex-1 items-center dark:filter-yellow"
                        [ngClass]="{ 'dark:filter-black': method === 'MOBILE-ID' }"
                        width="32"
                        height="auto"
                        alt=""
                        src="./assets/img/mobile-id.svg" />
                    <span
                        class="flex flex-1 items-center text-primary"
                        [ngClass]="method === 'MOBILE-ID' ? 'dark:text-contrast-black' : 'dark:text-contrast-yellow'">
                        {{ 'BTN_MOBILE_ID_LOGIN' | translate }}
                    </span>
                </button>

                <button
                    class="flex min-h-[5rem] flex-1 flex-col items-center justify-items-center rounded-md border-2 border-solid px-4 shadow-[0_0_20px_rgba(0,0,0,0.1)] dark:border-contrast-yellow"
                    *ngIf="env.AUTH_FEATURES?.includes('SMART-ID')"
                    [ngClass]="{
                        'border-secondary-button text-secondary-button bg-[#F1F8F5] dark:bg-contrast-yellow':
                            method === 'SMART-ID'
                    }"
                    [attr.disabled]="verificationCode ? 'true' : null"
                    (click)="setMethod('SMART-ID')">
                    <img
                        class="flex flex-1 items-center dark:filter-yellow"
                        [ngClass]="{ 'dark:filter-black': method === 'SMART-ID' }"
                        width="48"
                        height="auto"
                        alt=""
                        src="./assets/img/smart-id.svg" />
                    <span
                        class="flex flex-1 items-center text-primary"
                        [ngClass]="method === 'SMART-ID' ? 'dark:text-contrast-black' : 'dark:text-contrast-yellow'">
                        {{ 'BTN_SMART_ID_LOGIN' | translate }}
                    </span>
                </button>
            </div>
            <ridango-ui-basic-loading-spinner
                *ngIf="loading; else methodSelect"
                [ariaLabel]="'LOADER_LOADING_ARIA_LABEL' | translate">
            </ridango-ui-basic-loading-spinner>
            <ng-template #methodSelect>
                <div [ngSwitch]="method">
                    <div class="flex justify-center" *ngSwitchCase="'ID-CARD'">
                        <ion-button
                            class="login-web-button w-full lg:w-64"
                            [attr.aria-label]="'LINK_PERSONAL_CODE' | translate"
                            (click)="loginIdCard()"
                            type="submit"
                            size="large"
                            color="secondary">
                            <ion-label class="text-base font-semibold normal-case">
                                {{ 'LINK_PERSONAL_CODE' | translate }}
                            </ion-label>
                        </ion-button>
                    </div>
                    <div class="flex flex-col items-center" *ngSwitchCase="'MOBILE-ID'">
                        <mat-form-field class="w-full max-w-sm" appearance="outline">
                            <mat-label>{{ 'PERSONAL_CODE_EMPTY' | translate }}</mat-label>
                            <input [(ngModel)]="personalCode" matInput />
                        </mat-form-field>
                        <mat-form-field class="w-full max-w-sm" appearance="outline">
                            <mat-label>{{ 'ENTER_PHONE_NUMBER' | translate }}</mat-label>
                            <input [(ngModel)]="phoneNumber" matInput />
                        </mat-form-field>
                        <ion-button
                            class="login-web-button w-full lg:w-64"
                            [disabled]="polling"
                            [attr.aria-label]="'LINK_PERSONAL_CODE' | translate"
                            (click)="loginMobileId()"
                            type="submit"
                            size="large"
                            color="secondary">
                            <ion-label class="text-base font-semibold normal-case">
                                {{ 'LINK_PERSONAL_CODE' | translate }}
                            </ion-label>
                        </ion-button>
                    </div>
                    <div class="flex flex-col items-center" *ngSwitchCase="'SMART-ID'">
                        <mat-form-field class="w-full max-w-sm" appearance="outline">
                            <mat-label>{{ 'PERSONAL_CODE_EMPTY' | translate }}</mat-label>
                            <input [(ngModel)]="personalCode" matInput />
                        </mat-form-field>
                        <ion-button
                            class="login-web-button w-full lg:w-64"
                            [disabled]="polling"
                            [attr.aria-label]="'LINK_PERSONAL_CODE' | translate"
                            (click)="loginSmartId()"
                            type="submit"
                            size="large"
                            color="secondary">
                            <ion-label class="text-base font-semibold normal-case">
                                {{ 'LINK_PERSONAL_CODE' | translate }}
                            </ion-label>
                        </ion-button>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</div>
